import { render, staticRenderFns } from "./categorySettings.vue?vue&type=template&id=16b64126&scoped=true&"
import script from "./categorySettings.vue?vue&type=script&lang=js&"
export * from "./categorySettings.vue?vue&type=script&lang=js&"
import style0 from "./categorySettings.vue?vue&type=style&index=0&id=16b64126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b64126",
  null
  
)

export default component.exports